// extracted by mini-css-extract-plugin
export default {"headline":"InstructionDetailPage_headline__0tqMc","content":"InstructionDetailPage_content__nyrhA"};